import React, { ElementType, forwardRef, ReactNode } from 'react';
import { chakra, HeadingProps, useStyleConfig } from '@chakra-ui/react';

type Variants =
  | `h1`
  | `h1Shadow`
  | `h2`
  | `h2Shadow`
  | `h2ShadowSpan`
  | `h3`
  | `h3Shadow`
  | `h4`
  | `h4Shadow`
  | `h5`
  | `h5Shadow`
  | `h5Gray`
  | `h6`;

interface Props extends Omit<HeadingProps, `css`> {
  children?: ReactNode;
  as?: ElementType | any;
  variant?: Variants;
}

export const Heading = forwardRef<HTMLDivElement, Props>(
  ({ children, as, variant, ...props }, ref): JSX.Element => {
    const styles = useStyleConfig(`Heading`, { variant });

    return (
      <chakra.h2 as={as || variant} ref={ref} __css={styles} {...props}>
        {children}
      </chakra.h2>
    );
  }
);
export type { Props as HeadingProps };
